import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SellingCompanyNote } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SellingCompanyNoteService extends TmsWebBaseEditCreateService<SellingCompanyNote, SellingCompanyNote> {
  constructor() {
    super('SellingCompanyNote', $localize`Selling Company Note`);
  }

  getForSellingCompany(id: string): Observable<SellingCompanyNote[]> {
    return this.httpService.get<SellingCompanyNote[]>(`${this.apiUrl}/SellingCompanyNotes/${id}`);
  }
}
